replaceHashPath